export const FACTSHEET_ENGLISH = {
  "datox.studio.title": "Reports",
  "datox.studio.description": "Build portfolio dashboards with your own data categories, mappings and financial metrics.",
  "datox.studio.new": "New report",
  "datox.studio.blank": "Blank dashboard",
  "datox.studio.reuse": "Reuse a saved definition",
  "datox.studio.name": "Factsheet name",
  "datox.studio.create": "Create workspace",
  "datox.studio.empty": "Create your first factsheet dashboard, or choose a report template.",
  "datox.studio.search": "Search factsheets, portfolios or clients",
  "datox.studio.setup": "Details",
  "datox.studio.data": "Data",
  "datox.studio.review": "Review data",
  "datox.studio.dashboard": "Dashboard",
  "datox.studio.activity": "History",
  "datox.studio.saved": "All changes saved",
  "datox.studio.unsaved": "Unsaved changes",
  "datox.studio.save": "Save changes",
  "datox.studio.reload": "Reload saved version",
  "datox.studio.conflict": "This workspace changed elsewhere. Your edits are retained; reload the saved version before saving again.",
  "datox.studio.error": "The action could not finish. Check the inputs and try again.",
  "datox.studio.stale": "Inputs have changed since the last completed run. Refresh the data before publishing updated results.",
  "datox.studio.draft": "Draft",
  "datox.studio.ready": "Ready",
  "datox.studio.running": "Processing",
  "datox.studio.target": "Portfolio / share-class target",
  "datox.studio.targetID": "Stable target identifier",
  "datox.studio.targetName": "Portfolio name",
  "datox.studio.client": "Client identifier",
  "datox.studio.filter": "Source identifier or filter instructions",
  "datox.studio.addTarget": "Add portfolio",
  "datox.studio.asOf": "Reporting date",
  "datox.studio.currency": "Reporting currency",
  "datox.studio.benchmark": "Benchmark",
  "datox.studio.instructions": "Calculation and mapping guidance",
  "datox.studio.instructionsHint": "Describe financial methods, source identifiers, missing mappings or clarifications for the next run.",
  "datox.studio.template": "Report template",
  "datox.studio.noTemplate": "Dashboard only",
  "datox.studio.templateHint": "Reports are generated only when you select a template and run Generate template outputs.",
  "datox.studio.templateRun": "Generate template outputs",
  "datox.studio.extract": "Extract & calculate",
  "datox.studio.generate": "Build / refresh dashboards",
  "datox.studio.suggest": "Suggest categories with AI",
  "datox.studio.suggestions": "Suggested categories",
  "datox.studio.applySuggestion": "Add to definition",
  "datox.studio.category": "Category",
  "datox.studio.addCategory": "Add category",
  "datox.studio.categoryName": "Category name",
  "datox.studio.guidance": "Extraction guidance",
  "datox.studio.noCategories": "Define the data you need. Add a category or ask AI to suggest categories from selected files.",
  "datox.studio.addField": "Add field",
  "datox.studio.fieldName": "Field name",
  "datox.studio.type": "Data type",
  "datox.studio.unit": "Unit / currency / format",
  "datox.studio.required": "Required",
  "datox.studio.choices": "Allowed values (comma-separated)",
  "datox.studio.type.text": "Text",
  "datox.studio.type.number": "Number",
  "datox.studio.type.date": "Date",
  "datox.studio.type.boolean": "Boolean",
  "datox.studio.type.enum": "Selection",
  "datox.studio.duplicate": "Duplicate",
  "datox.studio.copyName": "{{name}} copy",
  "datox.studio.moveUp": "Move up",
  "datox.studio.moveDown": "Move down",
  "datox.studio.remove": "Remove",
  "datox.studio.mapping": "Source mapping",
  "datox.studio.autoMapping": "Resolve from selected sources",
  "datox.studio.part": "Sheet / page",
  "datox.studio.column": "Source column / evidence location",
  "datox.studio.sourcePreview": "Source preview",
  "datox.studio.noPreview": "Select a source file to inspect its available preview.",
  "datox.studio.sources": "Selected source files",
  "datox.studio.upload": "Upload files",
  "datox.studio.noResults": "Run extraction and calculation to review saved data here.",
  "datox.studio.moreRows": "Show more rows",
  "datox.studio.openEditor": "Open dashboard editor",
  "datox.studio.noDashboard": "Create a blank dashboard to design manually, or build dashboards with AI after saving your categories and sources.",
  "datox.studio.publishHint": "Use Preview, Publish and Share in the dashboard editor to distribute this factsheet.",
  "datox.studio.runs": "Run history",
  "datox.studio.noRuns": "No runs yet. Saved category definitions are ready to use when you add sources.",
  "datox.studio.resume": "Resume run",
  "datox.studio.cancel": "Cancel run",
  "datox.studio.openRun": "Run details",
  "datox.studio.versions": "Category versions",
  "datox.studio.useVersion": "Use selected revision",
  "datox.studio.nextPeriod": "Use for another period",
  "datox.studio.archive": "Archive report",
  "datox.studio.legacy": "Existing dashboards",
  "datox.studio.templates": "Report templates",
  "datox.studio.library": "Data library",
  "datox.studio.libraryHint": "Reuse category definitions across reporting periods. Open a factsheet workspace to edit its definition and mappings.",
  "datox.studio.adopt": "Use extracted categories",
  "datox.studio.staleLabel": "Refresh needed",
  "datox.studio.statusFilter": "Filter by status",
  "datox.studio.allStatuses": "All statuses",
  "datox.studio.discard": "Leave without saving your category and setup changes?",
  "datox.studio.runStatus.pending": "Pending",
  "datox.studio.runStatus.running": "Running",
  "datox.studio.runStatus.completed": "Completed",
  "datox.studio.runStatus.cancelled": "Cancelled",
  "datox.studio.runStatus.failed": "Failed",
  "datox.studio.runStatus.interrupted": "Interrupted",
  "datox.studio.runStatus.waiting_for_files": "Waiting for files",
  "datox.studio.runStatus.cancel_requested": "Cancelling",
  "datox.studio.runStatus.blocked": "Needs input",
  "datox.studio.scopeHint": "Definitions are reusable. Files, targets and results stay scoped to this project and period.",
  "datox.studio.saveFirst": "Save your changes before running or opening a dashboard.",
  "datox.factsheet.title": "Factsheet",
  "datox.factsheet.description": "Turn portfolio source files into a factsheet report and an editable dashboard with the Factsheet agent skill.",
  "datox.factsheet.outputs": "HTML factsheet reports and editable dashboards, backed by saved extraction and output tables.",
  "datox.factsheet.configure": "Set up a factsheet workflow",
  "datox.factsheet.step.workspace": "Project and period",
  "datox.factsheet.step.files": "Upload source files",
  "datox.factsheet.step.report": "Extract, calculate and report",
  "datox.factsheet.step.dashboard": "Create editable dashboard",
  "datox.factsheet.project": "Project",
  "datox.factsheet.projectName": "Project name",
  "datox.factsheet.projectPlaceholder": "For example, Portfolio reporting",
  "datox.factsheet.newProject": "Create a new project",
  "datox.factsheet.period": "Reporting period",
  "datox.factsheet.newPeriod": "Create a new period",
  "datox.factsheet.periodName": "New period name",
  "datox.factsheet.periodPlaceholder": "For example, Q2, 2026",
  "datox.factsheet.files": "Factsheet source files",
  "datox.factsheet.filesHint": "Upload positions or holdings, security reference and benchmark data. Include NAV, returns or cash-flow history when available. The agent will identify the fields and ask about any essential gaps.",
  "datox.factsheet.chooseFiles": "Choose files",
  "datox.factsheet.existingFiles": "Or select files already uploaded to this period",
  "datox.factsheet.removeFile": "Remove {{name}}",
  "datox.factsheet.uploaded": "Uploaded",
  "datox.factsheet.pending": "Ready to upload",
  "datox.factsheet.generate": "Generate factsheet",
  "datox.factsheet.generating": "Generating…",
  "datox.factsheet.retry": "Retry generation",
  "datox.factsheet.checkResults": "Check saved results",
  "datox.factsheet.refresh": "Refresh sources",
  "datox.factsheet.openWorkflow": "Open workflow",
  "datox.factsheet.openChat": "Continue with agent",
  "datox.factsheet.openDashboards": "Open dashboards",
  "datox.factsheet.openReport": "Open report",
  "datox.factsheet.ready": "Your factsheet reports and dashboards have been saved.",
  "datox.factsheet.needsInput": "The agent needs more information, or not all outputs have been saved yet. Continue in the agent chat, then check the saved results.",
  "datox.factsheet.error": "The factsheet workflow could not finish. Uploaded files and completed results are retained. Retry, or continue with the agent.",
  "datox.factsheet.loadError": "Could not load projects, periods or files. Refresh before continuing.",
  "datox.factsheet.preparing": "Preparing the project, period and uploaded files…",
  "datox.factsheet.uploading": "Uploading the selected source files to the reporting period…",
  "datox.factsheet.reporting": "The agent is reviewing the files, saving extracted data and generating factsheet reports…",
  "datox.factsheet.dashboarding": "The agent is building editable dashboards from the saved output tables…",
  "datox.factsheet.scopeHint": "Results are saved in the selected project and period. Use Workflow to inspect Files, Categories, Extractions, Transformations and Output.",
  "datox.factsheet.sessionTitle": "Factsheet · {{period}}",
} as const
